import * as React from "react";
import Ajax from "../../Ajax";
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";

interface IFormProps {

}
interface MyStates {
  date: object,
  selecteddate: object,
  data: object

}
export default class TouristTaxDatatable extends React.Component<IFormProps, MyStates>{

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      date: new Date(),
      selecteddate: new Date(),
      data: []
    }
    this.loadOrders()
  }

  private loadOrders(filters = {}) {
     var ajax = new Ajax(window.location.origin + '/reservatio/foglalasok/getTouristTax');
    ajax.doPost({
      date: this.state.date
    }).then((response) => {
      this.setState({
        data: response,
      })
    })
  }

  public handleChange(date){
    this.setState({
      date: date
    }, () => this.loadOrders())
  }


  public render() {

    return (
    <>
      <div className="box">
        <div className="box-header">
          <h3 className="box-title">Idegenforgalmi adó</h3>
          <div style = {{float: 'right'}}>
            <DatePicker
              selected={this.state.date}
              onChange={(e) => this.handleChange(e)}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              showFullMonthYearPicker
            />
          </div>
        </div>
        
        <div className="box-body table-responsive" style={{position: 'relative'}}>
          <table className="table ifa_table">
            <thead>
              <tr>
                <th>
                  Összes eltöltött vendégéjszaka száma (gyerekek, felnőttek, egyházi személyek)
                </th>
                <th>
                  Adóköteles vendégéjszakák száma 
                </th>
                <th>
                  Egyházi személyek által eltöltött vendégéjszakák száma 
                </th>
                <th>
                  18 év alattiak által eltöltött vendégéjszakák száma
                </th>
                <th>
                  Fizetendő adó összege
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {this.state?.data['group_size']}
                </td>
                <td>
                  {this.state?.data['group_size'] - this.state?.data['churchpersonnumber'] - this.state?.data['underage_people_count']}
                </td>
                <td>
                  {this.state?.data['churchpersonnumber']}
                </td>
                <td>
                  {this.state?.data['underage_people_count']}
                </td>
                <td>
                  { this.state?.data['ifa'] +' Ft'}
                </td>
              </tr>
            </tbody>
          </table>   
        </div>
        
      </div>

    </>
    )
  }

}